














































import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import StepBar from "@/components/Atoms/StepBar/index.vue";
import Button from "@/components/Atoms/Button/index.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "Panel",
  components: {
    Heading,
    StepBar,
    Button
  },
  props: {
    currentStep: {
      type: Number as PropType<Props["currentStep"]>,
      required: true
    },
    stepSettings: {
      type: Array as PropType<Props["stepSettings"]>,
      required: true
    },
    disabledOnNext: {
      type: Boolean as PropType<Props["disabledOnNext"]>,
      required: true
    },
    loading: {
      type: Boolean as PropType<Props["loading"]>,
      default: false
    }
  },
  computed: {
    currentSetting() {
      return this.stepSettings.find(
        stepSetting => stepSetting.step === this.currentStep
      );
    },
    stepCount() {
      return this.stepSettings.length;
      // return this.stepSettings.filter(stepSetting => !stepSetting.hide).length;
    }
  }
});
